<div class="gg-slider">
  <div class="gg-slider__bar" #bar>
    <div class="gg-slider__bg" [style.width]="currentStep?.position + '%'" [style.background-color]="((game === 'valorant' || game === 'apex' || game === 'marvel') && '#315cd9') || ((game === 'cs2' || game === 'apex') && '#5c8acb') || '#a4c2ff'"></div>
  </div>
  <div class="gg-slider__handle" [style.left]="currentStep?.position + '%'" #handle></div>
</div>
